import { render, staticRenderFns } from "./CamposDisponiveis.vue?vue&type=template&id=ae979ee8&scoped=true"
import script from "./CamposDisponiveis.vue?vue&type=script&lang=js"
export * from "./CamposDisponiveis.vue?vue&type=script&lang=js"
import style0 from "./CamposDisponiveis.vue?vue&type=style&index=0&id=ae979ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae979ee8",
  null
  
)

export default component.exports